import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "@/components/dashboard/shared/PageHeader";
import { KpiCard } from "@/components/dashboard/shared/KpiCard";
import { KpiGrid } from "@/components/dashboard/shared/KpiGrid";
import { BookingList } from "@/components/dashboard/bookings/BookingList";
import { DashboardHead } from "@/components/SEO/DashboardHead";
import api from "@/utils/api";
import { useCurrentStore } from "@/hooks/useCurrentStore";
import {
  RiCalendarLine,
  RiLineChartLine,
  RiTimeLine,
  RiCheckboxCircleLine,
  RiCloseCircleLine,
} from "@remixicon/react";

type BookingStats = {
  totalBookings: number;
  bookingRevenue: number;
  pendingBookings: number;
  confirmedBookings: number;
  cancelledBookings: number;
};

export function BookingsPage() {
  const { storeId, currentStore } = useCurrentStore();

  const { data: stats, isLoading } = useQuery<BookingStats>({
    queryKey: ["bookings-stats", storeId],
    queryFn: async () => {
      const { data } = await api.get("/api/analytics/bookings/stats");
      return data;
    },
    enabled: !!storeId,
  });

  return (
    <div className="space-y-6">
      <DashboardHead pageName="Bookings" />
      <PageHeader title="Bookings" subtitle="Manage appointments and booking requests." />

      <KpiGrid
        loading={isLoading}
        skeletonCount={5}
        columns="grid-cols-1 sm:grid-cols-2 xl:grid-cols-5"
      >
        <KpiCard
          label="Total Bookings"
          value={stats?.totalBookings ?? 0}
          icon={<RiCalendarLine />}
        />
        <KpiCard
          label="Booking Revenue"
          value={stats?.bookingRevenue ?? 0}
          currency={currentStore?.currency || "NGN"}
          icon={<RiLineChartLine />}
        />
        <KpiCard
          label="Pending"
          value={stats?.pendingBookings ?? 0}
          icon={<RiTimeLine />}
        />
        <KpiCard
          label="Confirmed"
          value={stats?.confirmedBookings ?? 0}
          icon={<RiCheckboxCircleLine />}
        />
        <KpiCard
          label="Cancelled"
          value={stats?.cancelledBookings ?? 0}
          icon={<RiCloseCircleLine />}
        />
      </KpiGrid>

      <BookingList />
    </div>
  );
}
